import { BasketService } from 'src/app/services/basket.service';
import { Router } from '@angular/router';
import { Store } from './../../store';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { EventsService } from 'src/app/services/events.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { TrybeService } from 'src/app/services/trybe.service';
import { BasketTotalsService } from 'src/app/services/basket-totals.service';
import { OpenTableService } from 'src/app/services/open-table.service';

@Component({
    selector: 'app-chkout-basket-totals',
    templateUrl: './chkout-basket-totals.component.html',
    styleUrls: ['./chkout-basket-totals.component.css']
})
export class ChkoutBasketTotalsComponent implements OnInit {
    @Input() basket;
    @Input() navParams;
    @Input() hotel;
    @Input() step = 'addOns';

    overlays$ = this.store.select<any>('overlays');
    infoPlan$ = this.store.select<any>('infoPlan');

    itemClass = 'col-12 col-md-6';
    events$ = this.store.select<any>('events');
    showComments = false;
    offeringInfo = undefined;
    basketItemIndex = -1;

    modalTreatmentsIdx = 1;
    itemChoices = [];
    showPackageItemsModal = false;


    stepsBar = [
        { name: 'Add Extras', step: 'addOns' },
        { name: 'Your Details', step: 'registration' },
        { name: 'Payment', step: 'payment' },
    ]

    events = [];

    eventParams = {
        source: 'checkout',
        nights: 1,
        stDate: undefined,
        hotelId: '',
        searchText: '',
        type: '',
        typeSlug: '',
        limit: 50,
        limits: [50, 100, 250],
        page: 0,
        pages: 0,
        pageArray: [],
        totalRecords: 0,
        sort: "event.name",
        sorts: [
            { ID: "event.firstname ASC", name: "Name A-Z" },
            { ID: "event.firstname DESC", name: "Name Z-A" },
            { ID: "event.createdAt DESC", name: "Recent First" },
            { ID: "event.createdAt ASC", name: "Recent Last" },
        ],
    };
    treatments = [];
    packageData = undefined;
    packageOptionToRemove = undefined;

    confirmationData = {
        title: 'Please confirm',
        detail: 'Are you sure you want to remove this treatment?',
        buttonText: 'Confirm'
    }
    showConfirmation = false;

    countdowns: number[] = [];
    private countdownIntervals: any[] = [];

    constructor(
        private store: Store,
        private router: Router,
        private basketService: BasketService,
        private eventsService: EventsService,
        private overlayService: OverlayService,
        private trybeService: TrybeService,
        private basketTotalsService: BasketTotalsService,
        private openTableService: OpenTableService,
        private cdRef: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        const basket = this.store.selectForLocal('basket');

        if (!basket.items.length) {
            this.router.navigate(['/'])
        }

        const hotel = basket.items[0].room.hotel;

        if (hotel === 'HOTEL002') {
            this.itemClass = 'col-12 col-md-4'
        }
        this.startCountdowns();
        setInterval(() => {
            this.cdRef.detectChanges(); // or update a dummy variable to trigger change detection
        }, 1000);
    }
    ngOnDestroy() {
        this.clearCountdowns();
    }
    viewTreatments(i) {
        this.router.navigate(['/', 'bookings', 'create', 'spa', i])
    }

    checkout() {
        const profile = this.store.selectForLocal('profile');

        if (!profile) {
            this.router.navigate(['/', 'checkout', 'registration', 'decision']);
        } else {
            this.router.navigate(['/', 'checkout', 'registration', 'profile']);
        }
    }

    viewHotel() {
        const basket = this.store.selectForLocal('basket');
        const hotel = basket.items[0].room.hotel;
        this.router.navigate(['/', hotel.slug]);
    }


    toggleComments(item) {
        if (!item.showComments) {
            item.showComments = true;
        } else {
            item.showComments = false;
        }
    }

    updateBasketComments() {
        for (let i = 0; i < this.basket.items.length; i++) {
            if (this.basket.items[i].comments) {
                this.basket.items[i].comments = this.basket.items[i].comments.replace(/\n/g, ' ');
            }
        }
        this.basketService.saveBasket(this.basket);
    }


    offeringModal(offering) {
        this.offeringInfo = offering;
    }
    closeOfferingModal(e) {
        this.offeringInfo = undefined;
    }

    triggerPackageItemModal(basketItemIndex, trybeBasketItemIndex, packageItemIndex) {
        this.treatments = [];

        const basketItem = this.basket.items[basketItemIndex];
        const trybeBasketItem = basketItem.spa.trybeBasket.items[trybeBasketItemIndex]

        this.packageData = {
            date: trybeBasketItem.date,
            basketId: basketItem.spa.trybeBasket.id,
            basketItemId: trybeBasketItem.id,
            optionId: trybeBasketItem.package_items[packageItemIndex].option_id,
            sessionId: trybeBasketItem.package_items[packageItemIndex].id,
            basketItem: trybeBasketItem,
            basketItemIndex,
            trybeBasketItemIndex,
            packageItemIndex,
        }

        this.trybeService.getPackage(trybeBasketItem.offering_id).subscribe(data => {
            this.itemChoices = data.data.data.item_choices;

            const treatments = data.data.data.item_choices[this.modalTreatmentsIdx];

            for (let o = 0; o < treatments.options.length; o++) {
                treatments.options[o].parentId = treatments.id
                this.treatments.push(treatments.options[o])
            }

            for (let ic = 0; ic < treatments.length; ic++) {
            }
            this.showPackageItemsModal = true;
        })
    }

    spaItemsComplete(e) {
        this.showPackageItemsModal = false;
        if (e.action) {
            this.basket.items[this.packageData.basketItemIndex].spa.trybeBasket = e.trybeBasket;
            this.basket.items[this.packageData.basketItemIndex].checkoutTotals = this.basketTotalsService.calculateItemTotals(this.basket, this.basket.items[this.packageData.basketItemIndex], this.basket.user)
            this.basket = this.basketTotalsService.totalBasket(this.basket);

            this.basketService.saveBasket(this.basket);
            if (+this.modalTreatmentsIdx < +this.itemChoices.length - 1) {
                console.log('trigger it just a little bit')
                this.modalTreatmentsIdx++;
                this.triggerPackageItemModal(this.packageData.basketItemIndex, this.packageData.trybeBasketItemIndex, this.packageData.packageItemIndex);
            } else {
                this.modalTreatmentsIdx = 1;
                this.packageData = undefined;
            }


        }
    }

    toggleSpaView(i) {
        if (!this.basket.items[i].spaView) {
            this.basket.items[i].spaView = true;
        } else {
            this.basket.items[i].spaView = false;
        }
    }

    confirmRemovePackageOption(basketItemIndex, trybeBasketItemIndex, packageItemIndex) {
        this.packageOptionToRemove = {
            basketItemIndex,
            trybeBasketItemIndex,
            packageItemIndex,
        }
        this.showConfirmation = true;
    }
    removePackageOption(e) {

        this.showConfirmation = false;
        if (e.action) {
            const trybeBasket = this.basket.items[this.packageOptionToRemove.basketItemIndex].spa.trybeBasket
            const trybeItem = trybeBasket.items[this.packageOptionToRemove.trybeBasketItemIndex];
            const trybeItemOption = trybeBasket.items[this.packageOptionToRemove.trybeBasketItemIndex].package_items[this.packageOptionToRemove.packageItemIndex];

            // const trybeItemId = '682604d65195e4265a040fd1';
            // const packageItemId = '682604df192435e10c0f62b0';

            const trybeItemId = trybeItem.id;
            const packageItemId = trybeItemOption.id;

            this.trybeService.removePackageOption(trybeBasket.id, trybeItemId, packageItemId).subscribe(data => {
                this.getBasket(trybeBasket.id)
            })

        }
    }

    toggleOptionSelected(itemIdx, optionIdx) {
        // this.optionErrorText = '';
        const basket = this.store.selectForLocal('basket');
        basket.items[itemIdx].booking.planSelected.optionText = '';
        basket.items[itemIdx].booking.planSelected.optionsText = basket.items[itemIdx].booking.planSelected.options[optionIdx].text;

        if (!basket.items[itemIdx].booking.planSelected.options[optionIdx].selected) {
            basket.items[itemIdx].booking.planSelected.options[optionIdx].selected = true;
        } else {
            basket.items[itemIdx].booking.planSelected.options[optionIdx].selected = true;
        }
        basket.items[itemIdx].booking.planSelected.options.forEach((e, i) => {
            if (i !== optionIdx) {
                e.selected = false;
            }
        })

        this.basketService.saveBasket(basket);
    }


    getBasket(basketId) {
        this.trybeService.basketGet(basketId).subscribe(data => {

            this.basket.items[this.packageOptionToRemove.basketItemIndex].spa.trybeBasket = data.data.data;
            this.basket.items[this.packageOptionToRemove.basketItemIndex].checkoutTotals = this.basketTotalsService.calculateItemTotals(this.basket, this.basket.items[this.packageOptionToRemove.basketItemIndex], this.basket.user)
            this.basket = this.basketTotalsService.totalBasket(this.basket);

            this.basketService.saveBasket(this.basket);

        })
    }

    removeOpenTable(idx) {
        const hotelId = this.basket.items[idx].tableBooking.hotelId;
        const reservationToken = this.basket.items[idx].tableBooking.lockResult.reservation_token;
        this.openTableService.deleteLock(hotelId, reservationToken).subscribe(data => {
            this.basketService.removeOpenTable(idx);
        })

    }

    dining() {
        this.router.navigate(['/', 'bookings', 'create', 'opentable'])
    }

    private startCountdowns() {
        this.basket.items.forEach((item, idx) => {
            this.updateCountdown(idx); // Set initial time
            const interval = setInterval(() => {
                this.updateCountdown(idx);
            }, 1000);
            this.countdownIntervals[idx] = interval;
        });
    }

    private updateCountdown(idx: number) {
        if (this.basket.items[idx].tableBooking) {
            const expiresAt = new Date(this.basket.items[idx].tableBooking.lockResult.expires_at + 'Z').getTime();
            const now = Date.now();
            const diffSeconds = Math.floor((expiresAt - now) / 1000);

            this.countdowns[idx] = Math.max(0, diffSeconds);

            if (diffSeconds < 60) {
                this.removeOpenTable(idx)
            }
            if (diffSeconds <= 0 && this.countdownIntervals[idx]) {
                clearInterval(this.countdownIntervals[idx]);
                this.countdownIntervals[idx] = null;
            }

        }

        this.cdRef.detectChanges();
    }


    private clearCountdowns() {
        this.countdownIntervals.forEach(interval => {
            if (interval) {
                clearInterval(interval);
            }
        });
    }

    secondsRemaining(idx: number): number {
        return this.countdowns[idx] ?? 0;
    }

    formatRemaining(seconds: number): string {
        seconds = seconds - 60;

        if (seconds >= 60) {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = seconds % 60;
            return `${this.pad(minutes)}:${this.pad(remainingSeconds)} `;
        } else {
            return `${seconds} seconds`;
        }
    }

    private pad(n: number): string {
        return n < 10 ? '0' + n : n.toString();
    }

}
